function eq(left, right) {
  return left === right;
}

export { eq as default };
//# sourceMappingURL=eq.js.map
